import form from 'state/analytics/events/form';
import auth from 'state/analytics/events/auth';
import orders from 'state/analytics/events/orders';
import salesIntelligence from 'state/analytics/events/salesIntelligence';
import addresses from 'state/analytics/events/addresses';

const zipcodeError = ({ type, zipcode }) => ({
  eventName: 'zip_code_error',
  eventData: { type, zipcode, error_type: type },
});

const badRouteError = () => ({
  eventName: 'SA_unsupported route',
  eventData: {},
});

const shipperSoRepeatClicked = ({ type, orderId, place }) => ({
  eventName: 'shipper_so_repeat_clicked',
  eventData: {
    type,
    place,
    shipper_order_id: orderId,
  },
});

const shipperSoRepeatSubmitted = ({ type, orderId }) => ({
  eventName: 'shipper_so_repeat_submitted',
  eventData: {
    type,
    shipper_order_id: orderId,
  },
});

const shipperDownloadCsv = ({
  status,
  first_pickup_time,
  last_dropoff_time,
  email,
}) => ({
  eventName: 'shipper_shipments_download_csv',
  eventData: {
    status,
    first_pickup_time,
    last_dropoff_time,
    email,
  },
});

const shipperDownloadPodZip = ({
  status,
  first_pickup_time,
  last_dropoff_time,
  email,
}) => ({
  eventName: 'shipper_shipments_download_pod_zip',
  eventData: {
    status,
    first_pickup_time,
    last_dropoff_time,
    email,
  },
});

const shipperOrderPrint = ({ place, orderId }) => ({
  eventName: 'SA_shipper_shipments_print',
  eventData: {
    shipper_order_id: orderId,
    place,
  },
});

const shipperOrderCancelClicked = ({ place, orderId }) => ({
  eventName: 'SA_shipper_form_cancelled_clicked',
  eventData: {
    shipper_order_id: orderId,
    place,
  },
});

const shipperOrderEditClicked = ({ place, orderId, status }) => ({
  eventName: 'SA_shipper_form_edit_clicked',
  eventData: {
    shipper_order_id: orderId,
    status,
    place,
  },
});

const shipperOrderEditDiscard = ({ place, orderId }) => ({
  eventName: 'SA_shipper_form_edit_discard',
  eventData: {
    shipper_order_id: orderId,
    place,
  },
});

const shipperOrderEditSubmitted = ({ orderId, commands, diff }) => ({
  eventName: 'SA_shipper_form_edit_submitted',
  eventData: {
    shipper_order_id: orderId,
    commands,
    diff,
  },
});

const shipperOrderTrackingPageRedirect = ({ orderId, place }) => ({
  eventName: 'SA_shipper_tracking_page_redirect',
  eventData: {
    shipper_order_id: orderId,
    place,
  },
});

const shipperOrderCopyTrackingPageLink = ({ orderId, place }) => ({
  eventName: 'SA_shipper_copy_tracking_page_link',
  eventData: {
    shipper_order_id: orderId,
    place,
  },
});

const trackingPageOntruckLogoClick = ({ orderId }) => ({
  eventName: 'SA_tracking_page_ontruck_logo_click',
  eventData: {
    shipper_order_id: orderId,
  },
});

const trackingPageLoaded = ({ orderId }) => ({
  eventName: 'SA_tracking_page_loaded',
  eventData: {
    shipper_order_id: orderId,
  },
});

const shipperOrderCancelSubmitted = ({ orderId, reason }) => ({
  eventName: 'SA_shipper_form_cancelled_submitted',
  eventData: {
    shipper_order_id: orderId,
    reason,
  },
});

const recurringOrderConfigurationOpened = ({ orderId, recurringOrderId }) => ({
  eventName: 'SA_open_recurring_order_configuration',
  eventData: { orderId, recurringOrderId },
});

const badPaymentMethodRecurring = ({ data, quote }) => ({
  eventName: 'SA_bad_payment_method_recurring',
  eventData: {
    data,
    quote,
  },
});

const bannerInternationalQuoteClicked = () => ({
  eventName: 'SA_banner_quote_international',
  eventData: {},
});

const bannerNLSendClicked = ({ userEmail }) => ({
  eventName: 'SA_banner_nl_send_clicked',
  eventData: { userEmail },
});

const bannerNLSendClosed = ({ userEmail }) => ({
  eventName: 'SA_banner_nl_send_closed',
  eventData: { userEmail },
});

const bannerNLSendDisplayed = ({ userEmail }) => ({
  eventName: 'SA_banner_nl_send_displayed',
  eventData: { userEmail },
});

const bannerFRRhoneAlpesDisplayed = ({ userEmail }) => ({
  eventName: 'SA_banner_fr_rhone_alpes_displayed',
  eventData: { userEmail },
});

const bannerFRRhoneAlpesClosed = ({ userEmail }) => ({
  eventName: 'SA_banner_fr_rhone_alpes_closed',
  eventData: { userEmail },
});

const bannerHolidaysClicked = () => ({
  eventName: 'SA_banner_holidays_clicked',
  eventData: {},
});

const bannerHolidaysRemoved = () => ({
  eventName: 'SA_banner_holidays_removed',
  eventData: {},
});

const paymentDataRequestPage = () => ({
  eventName: 'SA_payment_data_request_page',
  eventData: {},
});

const paymentDataRequestPageSubmit = ({ data }) => ({
  eventName: 'SA_payment_data_request_page_submit',
  eventData: {
    data,
  },
});

const suggestedPriceShown = ({
  type,
  mainQuoteRequest,
  quote,
  quoteRequest,
}) => ({
  eventName: 'SA_suggested_price_shown',
  eventData: {
    type,
    mainQuoteRequest,
    quote,
    quoteRequest,
  },
});

const suggestedPriceClicked = ({
  type,
  mainQuoteRequest,
  quote,
  quoteRequest,
}) => ({
  eventName: 'SA_suggested_price_clicked',
  eventData: {
    type,
    mainQuoteRequest,
    quote,
    quoteRequest,
  },
});

const bulkUploadClicked = () => ({
  eventName: 'SA_bulk_upload_clicked',
  eventData: {},
});

const bulkUploadEmailCopied = () => ({
  eventName: 'SA_bulk_upload_email_copied',
  eventData: {},
});

const bulkUploadShown = () => ({
  eventName: 'SA_bulk_upload_shown',
  eventData: {},
});

const priceBreakdownXDockTagHover = () => ({
  eventName: 'SA_price_breakdown_xdock_tag_hover',
  eventData: {},
});

const openFaqsModal = () => ({
  eventName: 'SA_shipper_open_faqs_modal',
});

const openOfferPdf = ({ data }) => ({
  eventName: 'SA_shipper_open_offer_pdf',
  eventData: {
    ...data,
  },
});

const campaignEvent = ({ eventName, eventData }) => ({
  eventName,
  eventData,
});

const UtmCampaignEvent = ({ eventData }) => ({
  eventName: 'SA_cta_utm_campaign',
  eventData,
});

const additionalDocuments = {
  submit: ({ orderId, numItems }) => ({
    eventName: 'SA_additional_documents_submit',
    eventData: {
      orderId,
      numItems,
    },
  }),
  fail: ({ orderId }) => ({
    eventName: 'SA_additional_documents_fail',
    eventData: {
      orderId,
    },
  }),
};

const captureLead = {
  view: ({ where }) => ({
    eventName: 'SA_capture_lead_view',
    eventData: { where },
  }),
  click: ({ where }) => ({
    eventName: 'SA_capture_lead_click',
    eventData: { where },
  }),
};

const orderModeChange = (type, data) => ({
  eventName: 'SA_order_mode_change',
  eventData: {
    type,
    data,
  },
});

const tooltipShownEvent = ({ title, content, extraData }) => ({
  eventName: 'SA_tooltip_shown',
  eventData: {
    title,
    content,
    extraData,
  },
});

const pageView = ({ location }) => ({
  eventName: 'SA_page_view',
  eventData: {
    location,
  },
});

const catalogStepContinue = ({ from, to }) => ({
  eventName: 'SA_catalog_step_continue',
  eventData: { from, to },
});

const catalogStepBack = ({ from, to }) => ({
  eventName: 'SA_catalog_step_back',
  eventData: { from, to },
});

const catalogLogoBack = ({ from }) => ({
  eventName: 'SA_catalog_logo_back',
  eventData: { from },
});

export default {
  auth,
  form,
  orders,
  salesIntelligence,
  addresses,
  zipcodeError,
  badRouteError,
  shipperSoRepeatClicked,
  shipperSoRepeatSubmitted,
  shipperDownloadCsv,
  shipperDownloadPodZip,
  shipperOrderPrint,
  shipperOrderCancelClicked,
  shipperOrderCancelSubmitted,
  shipperOrderEditClicked,
  shipperOrderEditDiscard,
  shipperOrderEditSubmitted,
  shipperOrderTrackingPageRedirect,
  shipperOrderCopyTrackingPageLink,
  trackingPageOntruckLogoClick,
  trackingPageLoaded,
  recurringOrderConfigurationOpened,
  badPaymentMethodRecurring,
  bannerInternationalQuoteClicked,
  bannerNLSendClicked,
  bannerNLSendClosed,
  bannerNLSendDisplayed,
  bannerFRRhoneAlpesDisplayed,
  bannerFRRhoneAlpesClosed,
  bannerHolidaysClicked,
  bannerHolidaysRemoved,
  bulkUploadClicked,
  bulkUploadEmailCopied,
  bulkUploadShown,
  paymentDataRequestPage,
  paymentDataRequestPageSubmit,
  suggestedPriceShown,
  suggestedPriceClicked,
  priceBreakdownXDockTagHover,
  openFaqsModal,
  openOfferPdf,
  campaignEvent,
  UtmCampaignEvent,
  additionalDocuments,
  captureLead,
  orderModeChange,
  tooltipShownEvent,
  pageView,
  catalogStepContinue,
  catalogStepBack,
  catalogLogoBack,
};
